import { MagikUI } from "@inmagik/magik-ui"
import { Route, Routes } from "react-router-dom"
import { AuthLayout } from "./components/AuthLayout"
import { GuestLayout } from "./components/GuestLayout"
import { AttivazioneAccount } from "./pages/AttivazioneAccount"
import Blog from "./pages/Blog/Blog"
import BlogCreate from "./pages/Blog/BlogCreate"
import BlogUpdate from "./pages/Blog/BlogUpdate"
import DocumentCreate from "./pages/Documents/DocumentCreate"
import Documents from "./pages/Documents/Documents"
import DocumentUpdate from "./pages/Documents/DocumentUpdate"
import GroupOfResearchCreate from "./pages/GroupOfResearches/GroupOfResearchCreate"
import GroupsOfResearches from "./pages/GroupOfResearches/GroupOfResearches"
import GroupOfResearchUpdate from "./pages/GroupOfResearches/GroupOfResearchUpdate"
import { Home } from "./pages/Home"
import KeywordCreate from "./pages/Keywords/KeywordCreate"
import Keywords from "./pages/Keywords/Keywords"
import KeywordUpdate from "./pages/Keywords/KeywordUpdate"
import { Login } from "./pages/Login"
import Media from "./pages/Media/Media"
import MediaCreate from "./pages/Media/MediaCreate"
import MediaUpdate from "./pages/Media/MediaUpdate"
import NamedEntities from "./pages/NamedEntities/NamedEntities"
import NamedEntityCreate from "./pages/NamedEntities/NamedEntityCreate"
import NamedEntityUpdate from "./pages/NamedEntities/NamedEntityUpdate"
import { PasswordDimenticata } from "./pages/PasswordDimenticata"
import Profilo from "./pages/Profilo/Profilo"
import { ResetPassword } from "./pages/ResetPassword"
import ResourceCreate from "./pages/Resources/ResourceCreate"
import Resources from "./pages/Resources/Resources"
import ResourceUpdate from "./pages/Resources/ResourceUpdate"
import TextCreate from "./pages/Texts/TextCreate"
import Texts from "./pages/Texts/Texts"
import TextUpdate from "./pages/Texts/TextUpdate"
import UtenteCreate from "./pages/Utenti/UtenteCreate"
import UtenteUpdate from "./pages/Utenti/UtenteUpdate"
import Utenti from "./pages/Utenti/Utenti"
import Faqs from "./pages/Faqs/Faqs"
import FaqCreate from "./pages/Faqs/FaqCreate"
import FaqUpdate from "./pages/Faqs/FaqUpdate"

export function Navigation() {
  return (
    <MagikUI>
      <Routes>
        <Route path="/" element={<AuthLayout redirect_to="/login" />}>
          <Route index element={<Home />}></Route>
          <Route path="/utenti/utenti" element={<Utenti />}></Route>
          <Route path="/utenti/utenti/new" element={<UtenteCreate />}></Route>
          <Route path="/utenti/utenti/:id" element={<UtenteUpdate />}></Route>
          <Route path="/named-entities/named-entities" element={<NamedEntities />}></Route>
          <Route path="/named-entities/named-entities/new" element={<NamedEntityCreate />}></Route>
          <Route path="/named-entities/named-entities/:id" element={<NamedEntityUpdate />}></Route>
          <Route path="/documents/documents" element={<Documents />}></Route>
          <Route path="/documents/documents/new" element={<DocumentCreate />}></Route>
          <Route path="/documents/documents/:id/*" element={<DocumentUpdate />}></Route>
          <Route path="/text-contents/text-contents" element={<Texts />}></Route>
          <Route path="/text-contents/text-contents/new" element={<TextCreate />}></Route>
          <Route path="/text-contents/text-contents/:id" element={<TextUpdate />}></Route>
          <Route path="/media/media" element={<Media />}></Route>
          <Route path="/media/media/new" element={<MediaCreate />}></Route>
          <Route path="/media/media/:id" element={<MediaUpdate />}></Route>
          <Route path="/keywords/keywords" element={<Keywords />}></Route>
          <Route path="/keywords/keywords/new" element={<KeywordCreate />}></Route>
          <Route path="/keywords/keywords/:id" element={<KeywordUpdate />}></Route>
          <Route path="/resources/resources" element={<Resources />}></Route>
          <Route path="/resources/resources/new" element={<ResourceCreate />}></Route>
          <Route path="/resources/resources/:id/*" element={<ResourceUpdate />}></Route>
          <Route path="/group-of-researches/group-of-researches" element={<GroupsOfResearches />}></Route>
          <Route path="/group-of-researches/group-of-researches/new" element={<GroupOfResearchCreate />}></Route>
          <Route path="/group-of-researches/group-of-researches/:id" element={<GroupOfResearchUpdate />}></Route>
          <Route path="/blog/blog" element={<Blog />}></Route>
          <Route path="/blog/blog/new" element={<BlogCreate />}></Route>
          <Route path="/blog/blog/:id/*" element={<BlogUpdate />}></Route>
          <Route path="/faqs/faqs" element={<Faqs />}></Route>
          <Route path="/faqs/faqs/new" element={<FaqCreate />}></Route>
          <Route path="/faqs/faqs/:id" element={<FaqUpdate />}></Route>
          <Route path="/profilo" element={<Profilo />}></Route>
        </Route>
        <Route path="/login" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<Login />}></Route>
        </Route>
        <Route path="/password-dimenticata" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<PasswordDimenticata />}></Route>
        </Route>
        <Route path="/reset-password" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<ResetPassword />}></Route>
        </Route>
        <Route path="/attivazione-account" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<AttivazioneAccount />}></Route>
        </Route>
      </Routes>
    </MagikUI>
  )
}
